import React from 'react'
import ServicePage from './ServicePage'

const IndexPage = () => {
  return (
    <div className='bg-gray-100 p-2'>
      <ServicePage />
    </div>
  )
}

export default IndexPage